module.exports = __webpack_public_path__ + "img/file-music-fill.304757a5.svg";